import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { FORGET_USER } from './actionTypes';
import { forgetUserSuccessful, userForgetPasswordError } from './actions';

// AUTH related methods
import { postForgetPwd } from '../../../helpers/fackBackend_Helper';
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { forgotPasswordApi } from './api';

//Initilize firebase
const fireBaseBackend = getFirebaseBackend();

//If user is login then dispatch redux action's are directly from here.
function* forgotPwd(payload) {
  try {
      const response = yield call(forgotPasswordApi, payload);
      yield put(forgetUserSuccessful(response));
  } catch (error) {
      yield put(userForgetPasswordError(error));
  }
}

function* forgetSaga() {
  yield takeEvery(FORGET_USER, forgotPwd)
}

export default forgetSaga;